import React from 'react';

const Logo = ({className, white = false}: any) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={'40'}
      height="40"
      viewBox="0 0 40 40">
      <path
        fill={white ? '#FFFFFF' : '#000000'}
        fillRule="evenodd"
        d="M 40 18.828125 L 39.574219 18.878906 C 39.574219 18.878906 35.085938 15.308594 25.847656 11.839844 L 24.566406 14.082031 L 20.933594 20.585938 L 12.550781 1.386719 C 14.847656 0.480469 17.355469 0 19.972656 0 C 30.652344 0 39.359375 8.320312 40 18.828125 Z M 7.101562 35.308594 C 2.722656 31.625 0 26.132812 0 20 C 0 16.375 0.960938 13.011719 2.617188 10.078125 C 7.261719 11.199219 11.109375 14.238281 12.710938 18.613281 C 14.898438 24.535156 12.445312 31.199219 7.101562 35.308594 Z M 27.183594 15.570312 L 13.992188 39.089844 C 15.914062 39.675781 17.945312 39.996094 20.027344 39.996094 C 30.175781 39.996094 38.507812 32.53125 39.894531 22.769531 C 39.761719 22.664062 39.640625 22.558594 39.519531 22.449219 C 39.402344 22.34375 39.28125 22.238281 39.148438 22.128906 C 35.78125 19.464844 31.832031 17.382812 27.824219 15.730469 Z M 27.183594 15.570312 "
      />
    </svg>
  );
};
export default Logo;
